import { ResolvedStyleDefaultValue } from '../default-value/types';
import { applyThemeVariables } from './apply-theme-variables';
import {
  ColorValue,
  BorderValue,
  FontValue,
} from '../../types/metadata/stylesDefinition';
import {
  formatColor,
  formatBorder,
  formatFont,
  formatGeneric,
  formatNumeric,
} from './formatters';
import { getRuleForType } from './rules';
import { ThemeVariables } from './types';

export const resolveStyleCSSValue = (
  value: ResolvedStyleDefaultValue,
  { themeVariables }: { themeVariables: ThemeVariables } = {
    themeVariables: {},
  },
): string | undefined => {
  if (
    typeof value.defaultValue === 'undefined' ||
    value.defaultValue === null
  ) {
    return undefined;
  }
  const applyTheme = (val: string) => applyThemeVariables(val, themeVariables);
  const rule = getRuleForType(value.type);

  if (rule) {
    switch (rule.type) {
      case 'color':
        return formatColor(value.defaultValue as ColorValue, applyTheme);
      case 'border':
        return formatBorder(value.defaultValue as BorderValue, applyTheme);
      case 'font':
        return formatFont(value.defaultValue as FontValue, applyTheme);
      case 'stringOrNumber':
        return formatNumeric(
          { value: value.defaultValue as string | number, unit: rule.unit },
          (val) => applyThemeVariables(val, themeVariables),
        );
      case 'string':
      case 'boolean':
      default:
        return formatGeneric(value.defaultValue, applyTheme);
    }
  }

  return formatGeneric(value.defaultValue, applyTheme);
};
